import { render } from "./TestNumbersStep.vue?vue&type=template&id=1e1b3b78&scoped=true"
import script from "./TestNumbersStep.vue?vue&type=script&lang=ts"
export * from "./TestNumbersStep.vue?vue&type=script&lang=ts"

import "./TestNumbersStep.vue?vue&type=style&index=0&id=1e1b3b78&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1e1b3b78"

export default script